import { useState } from 'react';

export default function NotesPanel({ notes, onAdd, onDelete }) {
  const [text, setText] = useState('');

  const handleAdd = () => {
    if (!text.trim()) return;
    onAdd(text.trim());
    setText('');
  };

  return (
    <div style={{ maxWidth: 640 }}>
      {/* Add note input */}
      <div style={{
        background: '#fff', borderRadius: 16, padding: '1.25rem',
        border: '1.5px solid #e2e8f0', marginBottom: '1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}>
        <p style={{ fontSize: 12, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.08em', marginBottom: 10 }}>NEW NOTE</p>
        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && e.metaKey) handleAdd(); }}
          placeholder="Write a note… (⌘ + Enter to save)"
          rows={3}
          style={{
            width: '100%', border: 'none', outline: 'none', resize: 'none',
            fontSize: 14, color: '#374151', background: 'transparent',
            lineHeight: 1.6, fontFamily: 'inherit',
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
          <button
            onClick={handleAdd}
            disabled={!text.trim()}
            style={{
              padding: '8px 20px', borderRadius: 10, background: '#fef3c7',
              border: '1.5px solid #fde68a', color: '#92400e',
              fontWeight: 700, fontSize: 13, cursor: text.trim() ? 'pointer' : 'not-allowed',
              opacity: text.trim() ? 1 : 0.5, transition: 'all 0.15s',
            }}
          >
            + Save note
          </button>
        </div>
      </div>

      {/* Notes list */}
      {notes.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>📝</div>
          <p style={{ fontSize: 15, fontWeight: 600, color: '#374151', marginBottom: 6 }}>No notes yet</p>
          <p style={{ fontSize: 13 }}>Write your first note above</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {notes.map((note, i) => (
            <div
              key={note.id}
              style={{
                background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 14,
                padding: '1rem 1.25rem', position: 'relative',
                animation: 'fadeInUp 0.2s ease both',
                animationDelay: `${i * 30}ms`,
              }}
            >
              <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.7, paddingRight: 28, whiteSpace: 'pre-wrap' }}>
                {note.text}
              </p>
              <p style={{ fontSize: 11, color: '#a3a3a3', marginTop: 8 }}>{note.date}</p>
              <button
                onClick={() => onDelete(note.id)}
                style={{
                  position: 'absolute', top: 10, right: 10,
                  width: 24, height: 24, borderRadius: 6, border: 'none',
                  background: 'rgba(217,119,6,0.1)', color: '#d97706',
                  fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', transition: 'all 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#ef4444'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(217,119,6,0.1)'; e.currentTarget.style.color = '#d97706'; }}
              >×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
